import React, { useContext, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Accordion from 'react-bootstrap/Accordion';
import './TCModal.css'
import styles from './TCModal.module.css'
import { dataContext } from '../../../App';
import activityLogSubmission from '../../../helper/activitylog';
import analyticEvent from '../../../helper/gaEvent';
import { pushCleverTapEvent } from '../../../helper/clevertapFunction';

const TCModal = ({ showTCModal, setShowTCModal, showRefundModal, setShowRefundModal }) => {
  const { token, setToken, playerData, setPlayerData } = useContext(dataContext);

  function hideModalOperation() {
    setShowTCModal(false)
  }

  useEffect(() => {
    let msisdn = null;
    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission("termsConditions", msisdn);
    analyticEvent('termsConditions', 'termsConditions-view')
    // pushCleverTapEvent('CheckIn-TC');
  }, [])

  return (
    <>
      <div className={styles.tcModal}>
        <div className={styles.tcModalHeader}>
          <div className="headerTitle" style={{marginBottom: '8px'}}>
            <img src={require('./tc.png')} className={styles.tcModalIcon} alt="terms" />
            <span className={styles.tcModalTitle}>নিয়ম ও শর্তাবলী</span>
          </div>
          <p className={styles.tcModalDescription}>
          QUIZARD কুইজ গেমে আপনাকে স্বাগতম ! QUIZARD এ কুইজ খেলে দৈনিক, টুর্নামেন্ট ভিত্তিক আকর্ষণীয় পুরস্কার জিতে নিন । পাশাপাশি নিজের সাধারণ জ্ঞান ভিত্তিক দক্ষতা ও যাচাই করে ফেলুন ।
          </p>
        </div>

        <div className={styles.tcModalContent}>
          <Accordion className={styles.accordion}>
            <Accordion.Item eventKey="0" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>খেলার যোগ্যতা</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                QUIZARD কুইজ গেমটি সকল বয়সের এবং জাতীয়তার বাক্তিদের জন্য উন্মুক্ত । কিন্তু, যে কোনো ধরনের প্রতারণা, বাহ্যিক সাহায্যের ব্যবহার, বা কুইজ প্ল্যাটফর্মের সাথে হেরফের করার প্রচেষ্টা অবিলম্বে অযোগ্যতার কারণ হবে। অযোগ্য অংশগ্রহণকারীরা কোনো পুরস্কার বা পুরস্কারের জন্য যোগ্য হবে না। আয়োজক সত্তার কর্মচারী এবং পরিবারের সদস্যরা অংশগ্রহণের যোগ্য নন।
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>লিংক</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <a href="https://bl.quizard.live/" target="_blank" rel="noopener noreferrer">https://bl.quizard.live/</a>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>কীভাবে যোগদান করবেন</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                সাপ্তাহিক ৩০ টাকা চার্জে কুইজ প্রতিদিন, স্পোর্টস কুইজ, BCS প্রস্তুতি  এবং টুর্নামেন্ট কুইজ গুলো তে আপনি কুইজ খেলতে পারবেন| বাংলালিংক নাম্বার থেকে পেমেন্ট এর মাধ্যমে ব্যবহারকারীরা তাদের অ্যাকাউন্টটির সাবস্ক্রিপশন সম্পন্ন করতে পারবেন আর QUIZARD এ যোগদান করতে পারবেন ।    
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>কুইজ খেলার নিয়ম</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <ul>
                  <li>QUIZARD কুইজ গেমটিতে কুইজ প্রতিদিন, একাধিক টুর্নামেন্ট কুইজ এর পাশাপাশি ক্যাটাগরি কুইজের একাধিক সেগমেন্টে কুইজ খেলার সুযোগ থাকবে ।</li>
                  <li>QUIZARD এর প্রতিটি সেগমেন্টে সর্বোচ্চ ৬০টি পছন্দের প্রশ্ন থাকবে এবং দৈনিক ২ বার খেলা যাবে ।</li>
                  <li>প্রতি রাউন্ড এ অংশগ্রহণকারীদের প্রদত্ত বিকল্পগুলি থেকে সঠিক উত্তর নির্বাচন করতে হবে। অংশগ্রহণকারীরা প্রতিটি সঠিক উত্তরের জন্য ১ পয়েন্ট অর্জন করবে।</li>
                  <li>কুইজ এর উত্তর জমা দেওয়ার জন্য একটি নির্দিষ্ট সময়সীমা থাকবে।</li>
                  <li>দুটি রাউন্ড এর মধ্যে যে রাউন্ড এর স্কোর বেশি হবে, সেটিই ফাইনাল স্কোর হিসেবে গণনা করা হবে ।</li>
                  <li>Quizard এ যেকোনো সেগমেন্টে উইনার হতে হলে মিনিমাম ৩০ স্কোর করতে হবে</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>বিজয়ীদের পুরস্কার</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <b>টুর্নামেন্ট এর সময়সীমা :</b><br />
                ১লা জুলাই ২০২৬ থেকে ৩১শে ডিসেম্বর ২০২৬<br /><br />
                <b>সাপ্তাহিক ক্যাম্পেইন এর সময়সীমা :</b><br />
                প্রতি সোমবার  থেকে রবিবার  পর্যন্ত।<br /><br />
                QUIZARD কর্তৃপক্ষ বিজয়ীদের দৈনিক, সাপ্তাহিক, টুর্নামেন্ট ভিত্তিক পুরস্কার প্রদান করে থাকে ।<br /><br />
                <b>Quiz Protidin পুরস্কার:</b><br />
                প্রতিদিন: শীর্ষ ২০ জন ১০ টাকা মোবাইল রিচার্জ<br />
                ***এক সপ্তাহের ডেইলি  প্রাইজ একসাথে সপ্তাহের সোমবার  দেয়া হয়ে থাকে।<br /><br />
                <b>Sports Quiz পুরস্কার:</b><br />
                প্রতিদিন: শীর্ষ ২০ জন ১০ টাকা মোবাইল রিচার্জ<br />
                ***এক সপ্তাহের ডেইলি  প্রাইজ একসাথে সপ্তাহের সোমবার  দেয়া হয়ে থাকে।<br /><br />
                <b>BCS প্রস্তুতি পুরস্কারঃ</b><br />
                প্রতিদিন: শীর্ষ ২০ জন ১০ টাকা মোবাইল রিচার্জ<br />
                ***এক সপ্তাহের ডেইলি  প্রাইজ একসাথে সপ্তাহের সোমবার  দেয়া হয়ে থাকে।<br /><br />
                <b>টুর্নামেন্ট কুইজ পুরস্কারঃ</b><br />
                মেগা পুরস্কার: Samsung Galaxy A07<br />
                প্রতিদিন: শীর্ষ ২০ জন ১০ টাকা মোবাইল রিচার্জ<br /><br />
                ***এক সপ্তাহের ডেইলি  প্রাইজ একসাথে সপ্তাহের সোমবার  দেয়া হয়ে থাকে।<br />
                বিঃ দ্রঃ টুর্নামেন্টের মেগা উইনার হতে হলে ব্যবহারকারীকে সাবস্ক্রাইব করার দিন থেকে নিয়মিত সাপ্তাহিক রিনিউ রাখতে হবে, সার্ভিসে সক্রিয়ভাবে খেলতে হবে এবং টপ স্কোরার হতে হবে।
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="5" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>কুইজ প্রতিদিন এর বিজয়ী হবার নিয়মাবলী</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <ul>
                  <li>তুলনামূলক কম সময়ে সর্বাধিক সঠিক উত্তর প্রদানকারী দের মধ্যে মেধাক্রম অনুসারে প্রথম ২০ জন পর্যন্ত পুরস্কৃত করা হবে ।</li>
                  <li>দৈনিক অংশগ্রহণকারীদের মধ্যে সেরা ২০ সঠিক উত্তর প্রদানকারী কে বিজয়ী হিসেবে বিবেচিত করা হবে ।</li>
                  <li>কুইজ প্রতিদিন এ বিজয়ী হওয়ার জন্য অংশগ্রহণকারীকে পেইড সাবস্ক্রাইবার হতে হবে ।</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="6" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>স্পোর্টস কুইজ এর বিজয়ী হবার নিয়মাবলী</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <ul>
                  <li>তুলনামূলক কম সময়ে সর্বাধিক সঠিক উত্তর প্রদানকারী দের মধ্যে মেধাক্রম অনুসারে প্রথম ২০ জন পর্যন্ত পুরস্কৃত করা হবে ।</li>
                  <li>দৈনিক অংশগ্রহণকারীদের মধ্যে সেরা ২০ সঠিক উত্তর প্রদানকারী কে বিজয়ী হিসেবে বিবেচিত করা হবে ।</li>
                  <li>বিজয়ী হওয়ার জন্য অংশগ্রহণকারীকে পেইড সাবস্ক্রাইবার হতে হবে ।</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="7" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>BCS প্রস্তুতি কুইজ এর বিজয়ী হবার নিয়মাবলী</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <ul>
                  <li>তুলনামূলক কম সময়ে সর্বাধিক সঠিক উত্তর প্রদানকারী দের মধ্যে মেধাক্রম অনুসারে প্রথম ২০ জন পর্যন্ত পুরস্কৃত করা হবে ।</li>
                  <li>দৈনিক অংশগ্রহণকারীদের মধ্যে সেরা ২০ সঠিক উত্তর প্রদানকারী কে বিজয়ী হিসেবে বিবেচিত করা হবে ।</li>
                  <li>বিজয়ী হওয়ার জন্য অংশগ্রহণকারীকে পেইড সাবস্ক্রাইবার হতে হবে ।</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="8" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>কুইজ  টুর্নামেন্ট এর বিজয়ী হবার নিয়মাবলী</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <ul>
                  <li>তুলনামূলক কম সময়ে সর্বাধিক সঠিক উত্তর প্রদানকারী দের মধ্যে মেধাক্রম অনুসারে প্রথম ২০ জন পর্যন্ত পুরস্কৃত করা হবে ।</li>
                  <li>দৈনিক অংশগ্রহণকারীদের মধ্যে সেরা ২০ সঠিক উত্তর প্রদানকারী কে বিজয়ী হিসেবে বিবেচিত করা হবে ।</li>
                  <li>বিজয়ী হওয়ার জন্য অংশগ্রহণকারীকে পেইড সাবস্ক্রাইবার হতে হবে ।</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="9" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>রেফার কোড ব্যবহারের নিয়ম :</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                QUIZARD-এর মেন্যু বার থেকে Profile (প্রোফাইল) অপশনে গেলে আপনার রেফার কোডটি পেয়ে যাবেন।<br />
                <ul>
                  <li>আপনার রেফার কোড শেয়ার করুন। আপনার কোড ব্যবহার করে কেউ সাবস্ক্রিপশন করলে, সেটি সফল রেফার হিসেবে গণ্য হবে।</li>
                  <li>২টি সফল রেফার সম্পন্ন হলে, আপনি পাবেন ২০ টাকা মোবাইল রিচার্জ।</li>
                  <li>অন্য কারো রেফার কোড ব্যবহার করে সাবস্ক্রিপশন করলে, আপনি পরবর্তী রিনিউয়াল সম্পন্ন করলে ২০ টাকা মোবাইল রিচার্জ পাবেন।</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="10" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>আনসাবস্ক্রাইব করার নিয়ম</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                Quizard এর শর্তাবলি তে আন্সাবস্ক্রাইব অপশন থেকে আনসাবস্ক্রিপশন করতে হবে।
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="faq" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>সাধারণ জিজ্ঞাসা</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <ul>
                  <li>
                    <strong>আপনি Quizard কোথায় খেলতে পারেন?</strong><br />
                    উঃ <a href="https://bl.quizard.live/" target="_blank" rel="noopener noreferrer">https://bl.quizard.live/</a>
                  </li>
                  <li>
                    <strong>হেল্পলাইন নম্বরটি কি?</strong><br />
                    উঃ <a href="tel:8801988117755" style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}>8801988117755</a>
                  </li>
                  <li>
                    <strong>হেল্পলাইন ফোন করার সময়সূচী:</strong><br />
                    উঃ রবিবার থেকে বৃহস্পতিবার সকাল ১০টা থেকে  বিকাল ৬ টা পর্যন্ত |
                  </li>
                  <li>
                    <strong>সাপোর্ট ইমেইল আইডি কি?</strong><br />
                    উঃ <a href="mailto:quizard.live@gmail.com" style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}>quizard.live@gmail.com</a>
                  </li>
                  <li>
                    <strong>Quizard এর ফেসবুক লিংকটি কি?</strong><br />
                    <a href="https://www.facebook.com/quizard2024" target="_blank" rel="noopener noreferrer">https://www.facebook.com/quizard2024</a>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            {((playerData?.isSubscribe) || (playerData?.isSubscribeTournament) || (playerData?.isSubscribeSports) || (playerData?.isSubscribeBcs)) &&             <Accordion.Item eventKey="10" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>কিভাবে আন্সাবস্ক্রাইব করবেন</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
              আন্সাবস্ক্রাইব করতে ক্লিক করুন <span style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={()=>{setShowRefundModal(true);}}>এখানে</span>
              </Accordion.Body>
            </Accordion.Item>}
          </Accordion>
        </div>
      </div>
    </>
  )
}

export default TCModal